import { formatCurrency } from './formatters'

export function getStatusColor(status: string) {
  switch (status) {
    case 'Pendiente':
      return {
        bg: 'bg-yellow-100 dark:bg-yellow-900/30',
        text: 'text-yellow-700 dark:text-yellow-400',
        dot: 'bg-yellow-500',
        gradient: 'from-yellow-400 to-yellow-500',
      }
    case 'En Preparación':
      return {
        bg: 'bg-blue-100 dark:bg-blue-900/30',
        text: 'text-blue-700 dark:text-blue-400',
        dot: 'bg-blue-500 animate-pulse',
        gradient: 'from-blue-400 to-blue-500',
      }
    case 'Listo':
      return {
        bg: 'bg-green-100 dark:bg-green-900/30',
        text: 'text-green-700 dark:text-green-400',
        dot: 'bg-green-500',
        gradient: 'from-green-400 to-green-500',
      }
    case 'Entregado':
      return {
        bg: 'bg-gray-100 dark:bg-gray-800',
        text: 'text-gray-600 dark:text-gray-400',
        dot: 'bg-gray-400',
        gradient: 'from-gray-300 to-gray-400',
      }
    case 'Cancelado':
      return {
        bg: 'bg-red-100 dark:bg-red-900/30',
        text: 'text-red-700 dark:text-red-400',
        dot: 'bg-red-500',
        gradient: 'from-red-400 to-red-500',
      }
    default:
      return {
        bg: 'bg-gray-100 dark:bg-gray-800',
        text: 'text-gray-600 dark:text-gray-400',
        dot: 'bg-gray-400',
        gradient: 'from-gray-200 to-gray-300',
      }
  }
}

export function calculateTax(total: number, taxExempt: boolean): number {
  return taxExempt ? 0 : total - total / 1.18
}

export function calculateSubtotal(total: number, taxExempt: boolean): number {
  return taxExempt ? total : total / 1.18
}

export function formatOrderCurrency(amount: number): string {
  return formatCurrency(amount)
}
